import { INavigationState } from './types';

export const SLICE_NAMESPACE = 'navigation';

export const navigationInitialState: INavigationState = {
  categories: {
    list: [],
    loading: false,
    error: null,
  },
  menuLinks: {
    footer: [],
    header: [],
    sidebar: [],
  },
};
